import { Code, DataList, Dialog } from "@chakra-ui/react";
import React from "react";

export const AddressCardDialog = ({
  data,
  ip,
  type,
  addressCardDialogOpen,
  setAddressCardDialogOpen,
}) => {
  const formattedAddressData = [
    { label: "Name", value: `${data?.first_name} ${data?.last_name}` },
    { label: "Email", value: data?.email },
    { label: "Mobile No.", value: data?.phone },
    {
      label: "Address",
      value: data?.address,
    },
    { label: "Street", value: data?.street },
    { label: "Region", value: data?.region },
    { label: "City", value: data?.city },
    { label: "PostCode", value: data?.postcode },
    { label: "Country", value: data?.country },
    { label: "IP", value: <Code variant="outline">{ip}</Code> },
  ];


  const formattedCardData = [
    { label: "Card Holder", value: data?.holder },
    { label: "Card No.", value: data?.pan },
    { label: "Expiry", value: data?.expires },
    { label: "IP", value: <Code variant="outline">{ip}</Code> },
    
  ];
  const listToRender = type === "Address" ? formattedAddressData : formattedCardData;
  return (
    <Dialog.Root
      size="xs"
      placement="center"
      motionPreset="scale"
      open={addressCardDialogOpen}
      onOpenChange={(e) => {
        setAddressCardDialogOpen(e.open);
        if (!e.open) {
        }
      }}
    >
      <Dialog.Backdrop />
      <Dialog.Positioner>
        <Dialog.Content>
          <Dialog.Header textAlign="center">
            <Dialog.Title>{type} Info</Dialog.Title>
            <Dialog.CloseTrigger />
          </Dialog.Header>
          <Dialog.Body>
            <DataList.Root orientation="horizontal" divideY="1px" maxW="md">
              {listToRender?.map((item) => (
                <DataList.Item key={item.label} pt="4">
                  <DataList.ItemLabel width="40%" fontSize="xs">
                    {item?.label}
                  </DataList.ItemLabel>
                  <DataList.ItemValue fontSize="xs">
                    {item?.value}
                  </DataList.ItemValue>
                </DataList.Item>
              ))}
            </DataList.Root>
          </Dialog.Body>
        </Dialog.Content>
      </Dialog.Positioner>
    </Dialog.Root>
  );
};
